module.exports = __webpack_public_path__ + "img/uabc_radio_radar_1.007141f5.jpeg";